define([
    'text!./templates/offer-actions-button-bar.html',
    'text!./templates/basler-csr-dialog.html',
], (templateStr, csrTemplateStr) =>{

    const directive = function ($window, httpSettings, StateUtils, ContextService, EmailService, LocaleService, ModalService) { // NOSONAR
        return {
            restrict: 'E',
            template: templateStr,
            scope: {
                /** Document id for the print link */
                docId: '=',
                /** return operation */
                /** Style class to be added to the button bar */
                buttonBarStyle: '=',
                /** Function to call when clicking the back link.*/
                previous: '&',
                /** Back link will be displayed if this parameter is true */
                showBackLink: '=',
                /** Function to call when clicking the main button */
                next: '&',
                /** Label to print on the next button*/
                nextButtonLabelKey: '@?',
                /** Set how action buttons will be displayed */
                isFinish: '@?',
            },
            link: linkFunction,
        };

        function linkFunction(scope) {
            scope.downloadURI = httpSettings.serviceBaseURLs.quotedocument;
            scope.encodedDocId = encodeURIComponent(scope.docId);
            scope.documentNotFoundURL = `${`${$window.location.pathname.substring(0, $window.location.pathname.lastIndexOf('/'))}/QuoteDocumentError-`}${LocaleService.getCurrentLocale()}`;

            const submission = StateUtils.activeDataForState(true).model;
            scope.quoteId = submission.quoteID.value;
            scope.sessionId = submission.sessionUUID.value;
            scope.submission = submission;
            scope.dataProcessingConfirmed = ContextService.getDataProcessingConfirmed();
            scope.isDirectProduct = () => {
                return ContextService.isDirectProduct();
            };


            scope.showHelpPopup = () => {
                const emailInfo = {
                    quoteID: scope.quoteId,
                    sessionID: scope.sessionId,
                    language: LocaleService.getCurrentLocale(),
                };

                EmailService.emailCSRQuote('emailCSRQuote', emailInfo); //ignore response from the server: we want to support customer even there is error while sending email

                ModalService.showSimpleDialog(csrTemplateStr, {translations: { quoteId: scope.quoteId}});
            };


        }
    };

    directive.$inject = ['$window', 'httpSettings', 'StateUtils', 'ContextService', 'qnb.EmailService', 'LocaleService', 'ModalService'];
    return directive;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/OfferActionsButtonBar.js